<template>

        <v-card max-height="80vh">
            <v-card-title>{{ subscriptionTitle }}</v-card-title>

            <v-divider />

            <v-card-text style="min-height: 500px;">

                <div class="mt-4" id="ag-grid-container-subscriptions">
                    <ag-grid-vue style="width: 100%; height: 100%;" class="ag-theme-balham" v-if="showGrid"
                        :gridOptions="gridOptions"
                        :groupHeaders="true"
                        @row-double-clicked="(p) => editSubscription(p.data)"
                        :rowHeight="40">
                    </ag-grid-vue>
                </div>

                <v-btn class="mt-2" color="#c42111" @click="addSubscription">Add Subscription</v-btn>

                <v-dialog v-model="showEditSubscriptionSchedule" max-width="80%" width="800px" persistent v-if="showEditSubscriptionSchedule" @keydown="(k) => {k.key == 'Escape' ? showEditSubscriptionSchedule = false : null}">
                    <subscription-schedule :subscriptionSchedule="subscriptionScheduleClone" @cancel="cancelEdit" @save="saveSubscription" />
                </v-dialog>
                
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn text @click="$emit('close')">Close</v-btn>
            </v-card-actions>
        </v-card>

</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "../../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
import "../../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
import SubscriptionSchedule from '@/components/TelsasoftDashboard/SubscriptionSchedule';
export default {
    name: 'SubscriptionManagement',
    props: ['subscriptionType', 'subscriptionTypeId'],
    components: {
        'ag-grid-vue': AgGridVue,
        SubscriptionSchedule
    },
    data: () => ({
        subscriptions: [],
        subscriptionSchedules: [],
        showGrid: false,
        gridOptions: null,
        showEditSubscriptionSchedule: false,
        subscriptionScheduleClone: null,

    }),

    computed: {
        subscriptionTitle() {
            if(this.$props.subscriptionType = 'dashboard') {
                return 'Telsasoft Dashboard Subscriptions';
            }
            return 'Subscriptions';
        },

    },

    methods: {
        addSubscription: function() {
            this.subscriptionScheduleClone = {
                subscription_id: 0,
                recur_type: 'daily',
                recur_time: "",
                repeat_frequency: "1",
                repeat_on: null,
                start_date: TELSA.moment.tz(this.$store.state.batchConfig.timezone).format('YYYY-MM-DD'),
                end_date: "",
                expires_value: 1,
                expires_unit: 'days',
                recipients: [],
            }
            this.showEditSubscriptionSchedule = true;
        },

        cancelEdit: function() {
            this.showEditSubscriptionSchedule = false;
            this.subscriptionScheduleClone = null;
        },  

        getSubscriptionsList: function() {
            TELSA.loading(true);
            let route = `${TELSA.apiHost}subscriptions/list`;
            return this.$http.post(route, {args: {subscriptionType: this.$props.subscriptionType, subscriptionTypeId: this.$props.subscriptionTypeId}}).then(response => {
                let results = response.body;
                this.subscriptions = results;
                this.showGrid = false;
                this.$nextTick(function() {
                    this.buildAgGrid();
                    TELSA.loading(false);
                });
            });
        },

        buildAgGrid: function() {
            this.showGrid = false;
            this.gridOptions = {};
            this.gridOptions.rowData = this.subscriptions;
            this.gridOptions.columnDefs = this.createColumnDefs();

            let self = this;
            this.gridOptions.onGridReady = function(params) {
                self.gridOptions.api.hideOverlay();
                self.gridOptions.api.sizeColumnsToFit();
            }

            this.gridOptions.getContextMenuItems = function() {
                return [
                    'copy',
                    'copyWithHeaders',
                    'paste',
                    'csvExport',
                    'excelExport'
                ];
            };

            this.gridOptions.defaultColDef = {
                sortable: true,
                filter: true,
                resizable: true
            }
            this.showGrid = true;
        },

        createColumnDefs: function() {
            let self = this;
            let columnDefs = [];
            columnDefs = [
                { 
                    headerName: '', 
                    suppressSizeToFit: true,
                    width: 90, filter: 'text', cellStyle: {'padding-top': '5px', 'text-align': 'left', 'background-color': 'white', 'border-right': 'black solid 1px'},
                    cellRenderer: class {
                        init(params) {
                            this.params = params;
                            this.eGui = document.createElement('div');
                            this.eGui.innerHTML = `<span class="mdi mdi-pencil-circle subscription-action" style="cursor: pointer; color: #c42111; font-size: 20pt" />
                                <span class="mdi mdi-delete-circle subscription-action" style="cursor: pointer; color: #c42111; font-size: 20pt" />`;
                            
                            this.editButtonHandler = this.editButtonHandler.bind(this);
                            this.deleteButtonHandler = this.deleteButtonHandler.bind(this);

                            this.editButton = this.eGui.querySelectorAll('.subscription-action')[0];
                            this.deleteButton = this.eGui.querySelectorAll('.subscription-action')[1];
                            this.editButton.addEventListener('click', this.editButtonHandler);
                            this.deleteButton.addEventListener('click', this.deleteButtonHandler);
                        }
                        getGui() {
                            return this.eGui;
                        }
                        editButtonHandler(event) {
                            event.stopPropagation();
                            this.params.editFunction(this.params);
                        }
                        deleteButtonHandler(event) {
                            event.stopPropagation();
                            this.params.deleteFunction(this.params);
                        }
                        destroy() {
                            this.editButton.removeEventListener('click', this.editButtonHandler);
                            this.deleteButton.removeEventListener('click', this.deleteButtonHandler);
                        }
                    },
                    cellRendererParams: {
                        editFunction: (params) => {
                            this.editSubscription(params.data);
                        },
                        deleteFunction: (params) => {
                            this.deleteSubscriptionClick(params.data);
                        }
                    }
                },
                { 
                    headerName: 'Recipients', 
                    field: 'recipients', 
                    width: 210, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        let recipientValues = params.data.recipients.map(r => {
                            if(r.user_id) {
                                return self.$store.state.batchConfig.users.find(u => u.user_id == r.user_id).user_fullname;
                            }
                            else {
                                return r.email;
                            }
                        });
                        return recipientValues.join(', ');
                    }
                },
                { 
                    headerName: 'Recurs', 
                    field: 'recur_type', 
                    width: 60, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Time', 
                    field: 'recur_time', 
                    width: 60, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Repeat Frequency', 
                    field: 'repeat_frequency', 
                    width: 90, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        let type = 'Days'
                        if(params.data.recur_type == 'weekly') {
                            type = 'Weeks';
                        }
                        else if(params.data.recur_type == 'monthly') {
                            type = 'Months';
                        }
                        else if(params.data.recur_type == 'yearly') {
                            type = 'Years';
                        }
                        return `${params.data.repeat_frequency} ${type}`;
                    }
                },
                { 
                    headerName: 'Repeat On', 
                    field: 'repeat_on', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Start Date', 
                    field: 'start_date',
                    width: 80, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'End Date', 
                    field: 'end_date', 
                    width: 80, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Link Expires', 
                    field: 'repeat_on', 
                    width: 90, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        return `${params.data.expires_value} ${params.data.expires_unit}`;
                    }
                },
            ];
            return columnDefs;
        },

        editSubscription: function(subscription) {
            this.subscriptionScheduleClone = JSON.parse(JSON.stringify(subscription));
            this.subscriptionScheduleClone.recipients = this.subscriptionScheduleClone.recipients.map(r => {
                if(r.user_id) {
                    let user = this.$store.state.batchConfig.users.find(u => u.user_id == r.user_id)
                    return {
                        ...user,
                        type: 'user',
                        search: `${user.user_username}${user.user_fullname}`
                    };
                }
                else {
                    return r.email;
                }
            });

            this.showEditSubscriptionSchedule = true;
        },

        deleteSubscriptionClick: function(subscription) {
            this.$store.commit('showConfirmModal', {
                title: 'Confirm Delete',
                message: 'Are you sure you want to delete this subscription?',
                type: 'delete',
                confirmAction: () => {this.deleteSubscription(subscription);}
            });
        },

        deleteSubscription: function(subscription) {
            TELSA.loading(true);
            let route = `${TELSA.apiHost}subscriptions/delete`;
            return this.$http.post(route, {args: {subscription_id: subscription['subscription_id']}}).then(response => {
                let result = response.body;
                this.getSubscriptionsList();
            });
        },

        saveSubscription: function() {
            TELSA.loading(true);
            this.showEditSubscriptionSchedule = false;

            let route = `${TELSA.apiHost}subscriptions/edit`;
            if(!this.subscriptionScheduleClone.subscription_id) {
                route = `${TELSA.apiHost}subscriptions/add`;
                delete this.subscriptionScheduleClone.subscription_id;
            }
            for(let [index, recipient] of this.subscriptionScheduleClone.recipients.entries()) {
                this.subscriptionScheduleClone.recipients[index] = {
                    user_id: recipient.user_id ? recipient.user_id : null,
                    email: recipient.user_id ? null : recipient
                }
            }

            return this.$http.post(route, {args: {subscriptionType: this.$props.subscriptionType, subscriptionTypeId: this.$props.subscriptionTypeId, subscription: this.subscriptionScheduleClone}}).then(response => {
                let result = response.body;
                this.subscriptionScheduleClone = null;
                this.getSubscriptionsList();
            });
        }
    },

    watch: {
    },

    created() {
    },

    mounted() {
        this.getSubscriptionsList();
    }
};
</script>

<style scoped>

    #ag-grid-container-subscriptions {
        height: 450px;
        width: 100%;
    }

</style>
